import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ChipHelperService, StatusContext } from '@services';

@Component({
  selector: 'app-status-chip',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusChipComponent {
  status = input.required<number | null>();
  context = input.required<StatusContext>();

  #helper = ChipHelperService;

  readonly variant = computed(() => this.#helper.getItemStatusChipClassName(this.context(), this.status()));
  readonly statusName = computed(() => this.#helper.getItemStatusName(this.context(), this.status()));
}
